<script setup lang="ts">
import { NavArrowRight } from "@iconoir/vue";
import { RouterLink, type RouteLocationRaw } from "vue-router";

defineProps<{
  to: RouteLocationRaw;
}>();
</script>

<template>
  <li class="link-list-item">
    <RouterLink :to class="box item-content">
      <div>
        <header class="header">
          <slot name="header" />
        </header>
        <slot />
      </div>
      <NavArrowRight class="nav-arrow" aria-hidden="true" />
    </RouterLink>
  </li>
</template>

<style scoped>
.link-list-item {
  &:nth-child(even) {
    background-color: var(--bg-color-tr-even);
  }

  &:nth-child(odd) {
    background-color: var(--bg-color-tr-odd);
  }
}

.item-content {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  justify-content: space-between;
  color: var(--text-color-body);
  text-decoration: none;
}

.nav-arrow {
  flex-shrink: 0;
  inline-size: 1.8em;
  block-size: auto;
}

:deep(.header > *) {
  overflow-wrap: anywhere;
}
</style>
